import { render, staticRenderFns } from "./TruncatedText.vue?vue&type=template&id=130c0dbc&"
import script from "./TruncatedText.js?vue&type=script&lang=js&"
export * from "./TruncatedText.js?vue&type=script&lang=js&"
import style0 from "./TruncatedText.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
